/*
  28.10.2026 (choix Mathieu) : bandeau cookies Consentmo compacté en mobile (< 750 px).
  Le bandeau vit dans le shadow DOM de <csm-cookie-consent> : le CSS du thème n'y entre pas,
  on y injecte donc une feuille de style dès qu'il apparaît. Rien ne change au consentement
  lui-même (mêmes boutons, même app) : Refuser garde la même taille qu'Accepter.
  Avant : carte d'environ 350 px de haut, 3 boutons empilés. Après : environ 140 px, 3 boutons sur une ligne.
*/
(function () {
  var CSS = '@media (max-width:749px){' +
    '.cc-window.cc-window{transform:none!important;position:fixed!important;margin:0!important;left:8px!important;right:8px!important;bottom:8px!important;width:auto!important;max-width:none!important;padding:12px 14px!important;border-radius:14px!important}' +
    '.cc-window .csm-cmp-body{padding:0!important;gap:10px!important;flex-direction:column!important}' +
    '.cc-window .csm-banner-text-wrapper,.cc-window .cc-compliance{width:100%!important}' +
    '.cc-window .cc-message{font-size:12px!important;line-height:1.4!important;margin:0!important}' +
    '.cc-window .cc-link{font-size:12px!important;padding:0!important;margin-left:2px!important}' +
    '.cc-window .cc-compliance{display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;gap:8px!important;align-items:center!important}' +
    '.cc-window .cc-btn{flex:1 1 0!important;min-width:0!important;margin:0!important;padding:9px 6px!important;font-size:13px!important;line-height:1.2!important;white-space:nowrap!important}' +
    '.cc-window .cc-compliance .cc-btn:first-child{flex:0 0 auto!important;padding:9px 4px!important;font-size:12px!important;text-decoration:underline!important}' +
    '}';

  function inject() {
    var host = document.querySelector('csm-cookie-consent');
    var root = host && host.shadowRoot;
    if (!root) return false;
    if (!root.getElementById('mtr-cc')) {
      var st = document.createElement('style');
      st.id = 'mtr-cc';
      st.textContent = CSS;
      root.appendChild(st);
    }
    return true;
  }

  if (inject()) return;
  var tries = 0;
  var timer = setInterval(function () {
    if (inject() || ++tries > 60) clearInterval(timer);
  }, 250);
})();
